import React from 'react';
import { useTheme } from '@material-ui/core/styles';

import {
    SizeClassProvider
} from "src/shared_modules/veu-visitors-core/components/common/muiMediaQuery";

import MainNavAppBar from "./mainnav-appbar";

import './mainnav.css';

function MainNav() {
    const theme = useTheme();
    //set the variable for our css!
    const themedStyle = {
        "--themeSecondaryMain": theme.palette.secondary.main
    }
    return (<SizeClassProvider>
            <MainNavAppBar themedStyle={themedStyle} />
        </SizeClassProvider>);
}

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default MainNav;
